module.exports = __webpack_public_path__ + "img/equipment-item-3.8fcc0d4.png";